import React from 'react';
import mainbackground from '../../images/mainbackground.jpg'


function About() {
  return (
    <div className="about" style={{ backgroundImage: `url(${mainbackground})` }}>

      <img src={require(`../../images/Jili.jpg`)} alt="avatar" className="intro-img" />

      <p className="about-title">About Me</p>
      <p className="about-text">
        I am full-time software engineer and part-time web development teacher with knowledge and skills in C#, Java, Python, JavaScript, TypeScript and SQL. I have built a number of web site projects for learning and teaching (including front-end, back-end, and full stack) mainly using JavaScript/TypeScript, Express.js, GraphQL, Socket.io and REACT. This site is to share with you some of the web projects I have built and deployed. You can send me an email on the contact page if you are interested in working with me to build a fascinating web site.
      </p>


    </div>
  );
}

export default About;
